type SessionExpiredHandler = () => void;

let _onSessionExpired: SessionExpiredHandler | null = null;

export function setSessionExpiredHandler(
  handler: SessionExpiredHandler | null,
) {
  _onSessionExpired = handler;
}

export function getSessionExpiredHandler(): SessionExpiredHandler | null {
  return _onSessionExpired;
}
